module.exports = __webpack_public_path__ + "static/media/Voranmeldung.52f0d49a.pdf";